import Route from './route';

$(function () {
    if (Route !== "account-saved-cards") {
        if ($('body').data('loggedIn')) {
            axios.get('/account/saved-cards/ajax-show-storage-signup-modal').then(response => {
                if (response.data.showModal) {
                    $('#storageSignUpModal').modal('show');
                }
            });
        }
    }
});